module.exports = __webpack_public_path__ + "img/1e4jFd0-Do5NiFH7vzofN6E6RuhlbIeQ7.dc8cb749.png";